import { render, staticRenderFns } from "./ViewEmailMessageDialog.vue?vue&type=template&id=228cda2e"
import script from "./ViewEmailMessageDialog.vue?vue&type=script&lang=js"
export * from "./ViewEmailMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports